import React, { useState, useEffect } from "react";
import { DataGrid } from '@mui/x-data-grid';
import { findAllOrdersListEvent } from '../../../_events/orders-list/find_orders_list.event';
import { message } from "antd";
import PrimaryProgress from "../../../containers/progress/primary_progress";
import { buildDateTimeStr } from '../../../_utils/date_operations';

const OrdersInfo = (props) => {

    const columns = [
        { field: 'order_id', headerName: 'Pedido', width: 105 },
        { field: 'order_date', headerName: 'Feccha Ped.', width: 105 },
        { field: 'order_exp_date', headerName: 'Fecha Req.', width: 105 },
        { field: 'client_name', headerName: 'Cliente', width: 200 },
        { field: 'purchase_order', headerName: 'Orden de compra', width: 150 },
        { field: 'description', headerName: 'Descripción', width: 200 },
        { field: 'quantity', headerName: 'Cantidad', width: 110 },
        { field: 'departured_quantity', headerName: 'Cant. Despachada', width: 200 },
        { field: 'pending_quantity', headerName: 'Cant. Pendiente', width: 200 },
        { field: 'reserved_quantity', headerName: 'Cant. Reservada', width: 200 },
    ];

    const [loading, setLoading] = useState(false);
    const [data, setData] = useState([]);

    const findData = () => {
        setLoading(true);
        findAllOrdersListEvent()
        .then(data => {
            setData(data.list);
            props.setLastUpdate(data.list.length > 0 ? buildDateTimeStr(data.list[data.list.length - 1].date_created) : 'Sin datos');
            setLoading(false);
        })
        .catch(err => {
            message.error(err.message);
            setLoading(false);
        });
    }

    useEffect(() => {
        findData();
    }, []);   

    if(loading){
        return(
            <PrimaryProgress />
        );
    }
    else{
        return(
            <div style={{height:450, width: '100%' }}>
                <DataGrid
                    rows={data}
                    columns={columns}
                    pageSize={8}
                    rowsPerPageOptions={[8]}
                    checkboxSelection={false}
                    getRowId={(p) => p.uuid}
                />
            </div>
        );
    }
}

export default OrdersInfo;